import React from 'react';
import { useParams } from 'react-router-dom';
import UsePaymentStatus from '../../../hooks/queryHooks/usePaymentStatus';
import TicketPaymentStatusModal from '../../components/modals/ticketPaymentStatusModal/TicketPaymentStatusModal';
import TicketPaymentStatus from './components/TicketPaymentStatus';
import handleDownloadTickets from '../../../../utils/functions/handleDownloadTickets';
import { useAuth } from '../../../contexts/userContext/userContext';
import { useModal } from '../../../contexts/modalsContext/modalsContext';

function PaymentStatus() {
  const { setShowAuthModal } = useModal();
  const { accessToken } = useAuth();
  const { id } = useParams();
  const payment = UsePaymentStatus(id);

  const handleDownload = () => {
    try {
      if (!accessToken) {
        setShowAuthModal(true);
        return;
      }
      handleDownloadTickets(id, payment?.data?.statement_guid);
    } catch (error) {
      if (error?.response?.status === 403) {
        setShowAuthModal(true);
      }
    }
  };
  return (
    <div>
      <div className="hidden bg-green-gr" />
      {payment?.status && (
        <TicketPaymentStatus
          payment={payment}
          handleDownload={handleDownload}
        />
      )}
      <TicketPaymentStatusModal
        payment={payment}
        handleDownload={handleDownload}
      />
    </div>
  );
}

export default PaymentStatus;
